const initAccordions = (): void => {
  const accordions = document.querySelectorAll('.list-item');

  Array.prototype.forEach.call(accordions, (accordion: HTMLElement) => {
    const accordionButton = accordion.querySelector<HTMLElement>('button');
    const accordionContent = accordion.querySelector<HTMLElement>('.list-item-content');
    const accordionWrap = accordion.querySelector<HTMLElement>('.item-content-wrap');

    accordionButton?.addEventListener('click', () => {
      let height = 0;

      if (!accordion.classList.contains('list-item-opened') && accordionWrap) {
        height = accordionWrap.offsetHeight;
      }

      accordion.classList.toggle('list-item-opened');

      if (accordionContent) {
        accordionContent.style.height = `${height}px`;
      }
    });
  });
};

export default initAccordions;
